import { render, staticRenderFns } from "./CourierSelect.vue?vue&type=template&id=1139724f&scoped=true&"
import script from "./CourierSelect.vue?vue&type=script&lang=js&"
export * from "./CourierSelect.vue?vue&type=script&lang=js&"
import style0 from "./CourierSelect.vue?vue&type=style&index=0&id=1139724f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139724f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
